module.exports = __webpack_public_path__ + "img/feature_buy_id.5d107213.png";